// @flow
import React, { Component } from 'react'
import classnames from 'classnames'

import AuthService from 'client/utils/auth-service'
// $FlowFixMe
export default class extends Component {
  props: {
    auth: AuthService,
    redirectUri: string,// $FlowFixMe
    children: React$Element<*>,
    classes: string,
    connection: {
      name: string
    }
  }

  static displayName: any = 'WAAD Form'
// $FlowFixMe
  onSubmit: ((event: any) => void) = (event: SyntheticEvent) => {
    event.preventDefault()

    const { auth, connection, redirectUri } = this.props

    auth && auth.loginWithAuthorize({
      connection: connection.name,
      redirectUri,
      responseType: 'code'
    })
  }

  render (): any {
    const { classes = '', children } = this.props
    return (
      <form className='login__form' onSubmit={this.onSubmit}>
        <button className={classnames(['login__button', 'login__button--sso', classes])} type='submit'>
          {children}
        </button>
      </form>
    )
  }
}
